import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { FundaeComponent } from 'modules/trainings/components/Revamp/TrainingsDetail/Fundae'

export default function TrainingDetailFundaeTab() {
  return (
    <ResponsivePage.Body showHeader={false}>
      <FundaeComponent />
    </ResponsivePage.Body>
  )
}
